import C from '../actions/constants'

export const propertyTable = (state = {}, action) => {
    switch (action.type) {
        case C.SET_PROPERTY_TABLE_VALUES:
            return { ...state, ...action.payload }
        case C.CLEAR_PROPERTY_TABLE_VALUES:
            return {}
        default:
            return state
    }
}